/** @jsx React.DOM */
/**
 * Note View - View
 */
var React = require("react");
var markdown = require("markdown").markdown;

module.exports = React.createClass({displayName: 'exports',
  render: function () {
    /*jshint unused:false */
    var html = markdown.toHTML(this.props.note.get("text"));

    return (/*jshint ignore:start */
      React.createElement("div", null, 
        React.createElement("div", {className: "well well-small"}, 
          React.createElement("h2", {'data-qa-name': "note-view-title"}, 
            this.props.note.get("title")
          )
        ), 
        React.createElement("div", {dangerouslySetInnerHTML: {__html: html}})
      )
    /*jshint ignore:end */);
  }
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/page/note/view.jsx
 ** module id = 101
 ** module chunks = 0
 **/